import { render, staticRenderFns } from "./VesselTitle.vue?vue&type=template&id=f7f08792&scoped=true&"
import script from "./VesselTitle.vue?vue&type=script&lang=ts&"
export * from "./VesselTitle.vue?vue&type=script&lang=ts&"
import style0 from "./VesselTitle.vue?vue&type=style&index=0&id=f7f08792&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f08792",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
